import type { ThemeVersions } from './types';

export type Producer<
  // How to create the theme
  Creator extends object = object,
  // The mutable props of the theme
  State extends object = object,
  // The result, when state changes Creator + State produces theme
  Theme extends object = object,
> = (creator: Creator, state: State) => Theme;

export class ThemeBuilder<
  // How to create the theme
  Creator extends object = object,
  // The mutable props of the theme
  State extends object = object,
  // The result, when state changes Creator + State produces theme
  Theme extends object = object,
> {
  readonly version: ThemeVersions;
  readonly creator: Creator;
  private readonly producer: Producer<Creator, State, Theme>;

  constructor(version: ThemeVersions, creator: Creator, producer: Producer<Creator, State, Theme>) {
    this.version = version;
    this.creator = creator;
    this.producer = producer;
  }

  readonly produce = (state: State) => {
    return this.producer(this.creator, state);
  };
}
